import type { ProblemType } from '~/api/seller-after-sales/types'

export const HTTP_STATUS_CODE_UNPROCESSABLE_ENTITY = 422
export const HTTP_STATUS_CODE_BAD_REQUEST = 400

export const PROBLEM_ALREADY_DECLARED_TOAST_DURATION = 60 * 1000

export const PROBLEM_TYPES_EVIDENCE_REQUIRED = [
  'DAMAGED_PACKAGE',
  'OOW_ITEM',
  'ITEM_NOT_RECEIVED',
] as const satisfies Readonly<ProblemType[]>
